import {
  DELETE_TASK,
  ADD_TASK,
  UPDATE_TASK,
  ARCHIVE_TASK,
  UNARCHIVE_TASK,
  SET_TASK_SORTING,
  ADD_COMMENT,
  UPDATE_COMMENT,
  DELETE_COMMENT,
  ADD_REPLY,
  UPDATE_REPLY,
  DELETE_REPLY,
  ADD_MY_TASK,
  UPDATE_MY_TASK,
  DELETE_MY_TASK,
  ADD_COMMENT_TO_MY_TASK,
  UPDATE_COMMENT_TO_MY_TASK,
  DELETE_COMMENT_FROM_MY_TASK,
  ADD_COMMENT_REPLY_TO_MY_TASK,
} from "../types";
import configVars from "../../config";
import jwt_decode from "jwt-decode";
import { getCookie } from "../../common";

export const deleteTask =
  (id, column, post_status, task) => async (dispatch) => {
    const jwtDecoded = getCookie("sustainyou_user_jwt")
      ? jwt_decode(getCookie("sustainyou_user_jwt"))
      : null;
    try {
      let response = await fetch(
        `${configVars.apiUrl}sustainchange/v1/deletetask`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Basic ${configVars.auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: id, userid: jwtDecoded.id }),
        }
      );
      const result = await response.json();
      if (result.success) {
        const found = task?.responsible_persons?.find((person) => {
          return person.ID === jwtDecoded.id;
        });
        if (found) {
          dispatch({
            type: DELETE_MY_TASK,
            payload: {
              taskId: task?.id,
              taskType: task?.action_plan_timeline_start
                ? "ActionPlan"
                : "Implementation",
            },
          });
        }
      }
      dispatch({
        type: DELETE_TASK,
        payload: { task: id, column, post_status },
      });
      return { data: response, status: "success" };
    } catch (error) {
      return { status: "error" };
    }
  };

export const addTask = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { data, columnId } = body;
    let response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/createtask`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
      }
    );
    response = await response.json();
    const found = response?.data?.responsible_persons?.find((person) => {
      return person.ID === jwtDecoded.id;
    });
    if (found) {
      dispatch({
        type: ADD_MY_TASK,
        payload: {
          task: response?.data,
          taskType: response?.data?.action_plan_timeline_start
            ? "ActionPlan"
            : "Implementation",
        },
      });
    }
    if (response?.data)
      dispatch({
        type: ADD_TASK,
        payload: { task: response?.data, column: columnId },
      });
    return { status: "success" };
  } catch (error) {
    return { status: "error" };
  }
};
export const updateTask = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { data, columnId } = body;
    let response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/createtask`,
      {
        method: "PUT",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
      }
    );
    response = await response.json();
    const found = response?.data?.responsible_persons?.find((person) => {
      return person.id === jwtDecoded.id;
    });
    if (found) {
      // Code to update my task list
      dispatch({
        type: UPDATE_MY_TASK,
        payload: {
          task: response?.data,
          taskType: response?.data?.action_plan_timeline_start
            ? "ActionPlan"
            : "Implementation",
        },
      });
    } else {
      dispatch({
        type: DELETE_MY_TASK,
        payload: {
          taskId: response?.data?.id,
          taskType: response?.data?.action_plan_timeline_start
            ? "ActionPlan"
            : "Implementation",
        },
      });
    }
    dispatch({
      type: UPDATE_TASK,
      payload: { task: response?.data, column: columnId },
    });
    return { status: "success" };
  } catch (error) {
    return { status: "error" };
  }
};
export const archiveTask = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { data, columnId, task } = body;
    await fetch(`${configVars.apiUrl}sustainchange/v1/archive-tasks`, {
      method: "POST",
      headers: {
        Authorization: `Basic ${configVars.auth}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
    });
    const updatedTask = { ...task, post_status: "archive" };

    dispatch({
      type: ARCHIVE_TASK,
      payload: { task: updatedTask, column: columnId },
    });
    return { status: "success" };
  } catch (error) {
    return { status: "error" };
  }
};

export const unArchiveTask = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { data, columnId, task } = body;
    await fetch(`${configVars.apiUrl}sustainchange/v1/archive-tasks`, {
      method: "POST",
      headers: {
        Authorization: `Basic ${configVars.auth}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
    });

    const updatedTask = {
      ...task,
      post_status: "publish",
    };

    dispatch({
      type: UNARCHIVE_TASK,
      payload: { task: updatedTask, column: columnId },
    });
    return { status: "success" };
  } catch (error) {
    return { status: "error" };
  }
};

export const handleSortTasks = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { data, state } = body;
    let response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/sort-tasks`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
      }
    );
    await response.json();

    dispatch({
      type: SET_TASK_SORTING,
      payload: { data: { ...state } },
    });
    return { data: state, status: "success" };
  } catch (error) {
    console.log({ error });
    return { status: "error" };
  }
};

export const addComment = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { taskId, listId, comment, taskType } = body;
    let response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/task-comments`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...comment, userid: jwtDecoded.id }),
      }
    );
    let _comment = await response.json();

    if (comment?.comment_parent) {
      dispatch({
        type: ADD_REPLY,
        payload: {
          comment: _comment.data,
          taskId,
          listId,
          commentId: comment?.comment_parent,
        },
      });
      if (taskType) {
        dispatch({
          type: ADD_COMMENT_REPLY_TO_MY_TASK,
          payload: {
            taskId,
            taskType,
            commentId: comment?.comment_parent,
            reply: _comment.data,
          },
        });
      }
    } else {
      dispatch({
        type: ADD_COMMENT,
        payload: { comment: _comment.data, taskId, listId },
      });
      if (taskType) {
        dispatch({
          type: ADD_COMMENT_TO_MY_TASK,
          payload: { taskId, taskType, comment: _comment.data },
        });
      }
    }

    return { data: _comment?.data, status: "success" };
  } catch (error) {
    console.log({ error });
    return { status: "error" };
  }
};

export const updateComment = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { taskId, listId, comment, parent, taskType } = body;
    let response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/task-comments/`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...comment, userid: jwtDecoded.id }),
      }
    );
    let _comment = await response.json();
    if (parent && parent !== "0") {
      dispatch({
        type: UPDATE_REPLY,
        payload: {
          comment: _comment.data,
          taskId,
          listId,
          commentId: parent,
        },
      });
    } else {
      dispatch({
        type: UPDATE_COMMENT,
        payload: { comment: _comment.data, taskId, listId },
      });
      if (taskType) {
        dispatch({
          type: UPDATE_COMMENT_TO_MY_TASK,
          payload: { taskId, taskType, comment: _comment.data },
        });
      }
    }

    return { data: _comment?.data, status: "success" };
  } catch (error) {
    console.log({ error });
    return { status: "error" };
  }
};

export const deleteComment = (body) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const { taskId, listId, comment, parent, taskType } = body;
    let response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/delete-comments/`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...comment, userid: jwtDecoded.id }),
      }
    );
    await response.json();

    if (parent && parent !== "0") {
      dispatch({
        type: DELETE_REPLY,
        payload: {
          comment: comment,
          taskId,
          listId,
          commentId: parent,
        },
      });
    } else {
      dispatch({
        type: DELETE_COMMENT,
        payload: { comment: comment, taskId, listId },
      });
      if (taskType) {
        dispatch({
          type: DELETE_COMMENT_FROM_MY_TASK,
          payload: { commentId: comment?.comment_id, taskId, taskType },
        });
      }
    }

    return { data: comment, status: "success" };
  } catch (error) {
    console.log({ error });
    return { status: "error" };
  }
};
